import React from 'react';
import { motion } from 'framer-motion';
interface QuestionCardProps {
  sectionLabel: string;
  question: string;
  helperText?: string;
  required?: boolean;
  children: ReactNode;
}
export function QuestionCard({
  sectionLabel,
  question,
  helperText,
  required = false,
  children
}: QuestionCardProps) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.25,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col pb-20" data-id="element-1061">
      <div className="mb-8 sm:mb-10" data-id="element-1062">
        <span className="text-xs sm:text-sm font-semibold text-violetBlue uppercase tracking-wider mb-2 block" data-id="element-1063">
          {sectionLabel}
        </span>
        <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-primary mb-3 sm:mb-4" data-id="element-1064">
          {question}
          {required && <span className="text-destructive ml-1" data-id="element-1065">*</span>}
        </h2>
        {helperText && <p className="text-sm sm:text-base lg:text-lg text-secondary leading-relaxed" data-id="element-1066">
            {helperText}
          </p>}
      </div>
      {children}
    </motion.div>;
}